/* eslint-disable @nx/enforce-module-boundaries */
import { RouterConfigOptions, Routes } from '@angular/router';
import { ChangePasswordComponent, ConfirmEmailComponent, ContactUsComponent, ForgotPasswordComponent, LoginComponent, NewPasswordComponent, SendConfirmEmailComponent, homeGuard } from '@core';
import { AppLayout } from './layout/components/app.layout';
import { ProxHomeComponent } from './layout/prox.home.component';

export const routerOptions: RouterConfigOptions = {
  paramsInheritanceStrategy: 'always',
};

export const routes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        canActivate: [homeGuard],
        component: ProxHomeComponent,
      },
      {
        path: 'account-user',
        loadChildren: () =>
          import('@account-user').then((m) => m.AccountUserModule),
      },
      {
        path: 'account',
        loadChildren: () => import('@account').then((m) => m.AccountModule),
      },
      {
        path: 'supplier',
        loadChildren: () => import('@supplier').then((m) => m.SupplierModule),
      },
      {
        path: 'account-admin',
        loadChildren: () =>
          import('@account-admin').then((m) => m.AccountAdminModule),
      },
      {
        path: 'global',
        loadChildren: () =>
          import('@global').then((m) => m.GlobalModule),
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'auth/change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'auth/confirm-email',
    component: ConfirmEmailComponent,
  },
  {
    path: 'auth/send-confirm-email',
    component: SendConfirmEmailComponent,
  },
  {
    path: 'auth/forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'auth/new-password',
    component: NewPasswordComponent,
  },
  {
    path: 'auth/contact-us',
    component: ContactUsComponent,
  },
  // Email link scanners rewrite the letters of our links (auth/new-password arrives as
  // bhgu/afj-cbffjbee). Without this, every such link throws NG04002 to Sentry.
  { path: '**', redirectTo: '' },
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes, routerOptions)],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
